import Index from "../../pages/sakura/recall/index";

const base = "recall";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/sakura/recall.js